let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jBidU")).then(() => parcelRequire('eRBH7'));